import { useBoolean } from '@fluentui/react-hooks';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { FC } from 'react';
import { NavigateFunction, useNavigate, useParams } from 'react-router';
import { applicationInsightsReactPlugin } from '../../../ApplicationInsightsService';
import { DrillDownContextProvider } from '../../../contexts/drillDownContext';
import FormViewProvider from '../../../contexts/formViewContext';
import { GridScrollContextProvider } from '../../../contexts/gridScrollContext';
import { searchOnType, SearchTableContextProvider } from '../../../contexts/searchTableContext';
import TaxReturnEventHandlerProvider from '../../../contexts/taxReturnEventHandlerContext';
import { useUserSettings } from '../../../contexts/useUserSettings';
import { VarianceNavigationContextProvider } from '../../../contexts/varianceNavigationContext';
import { COMPARE_REPORT_URL, REPORTS_TABLE_URL } from '../../../utils/Urls.constant';
import ReturnHasBeenDeletedNotificationModal from '../../common/ReturnHasBeenDeletedNotificationModal';
import ReportLinesTable from './ReportLinesTable';

const ReportLines: FC = () => {
    const params = useParams();
    const reportId = params.reportId ? parseInt(params.reportId) : 0;
    const tocItemId = params.id;

    const navigate: NavigateFunction = useNavigate();
    const navigateToCompareReport = (versionId: string, selectedEntities: string[]) => {
        navigate(`${COMPARE_REPORT_URL}${reportId}/${versionId}?selectedEntities=${selectedEntities?.join(',')}`);
    };
    const [isReturnHasBeenDeletedModalOpen, { setTrue: openReturnHasBeenDeletedModal, setFalse: closeReturnHasBeenDeletedModalOpen }] =
        useBoolean(false);
    const { removeReturn } = useUserSettings();

    const onConfirmDeletionModal = () => {
        closeReturnHasBeenDeletedModalOpen();
        removeReturn(reportId);
        navigate(REPORTS_TABLE_URL);
    };

    return (
        <DrillDownContextProvider>
            <SearchTableContextProvider searchOn={searchOnType.Report}>
                <GridScrollContextProvider>
                    <FormViewProvider returnKey={reportId} tocItemId={tocItemId}>
                        <VarianceNavigationContextProvider>
                            <TaxReturnEventHandlerProvider reportId={reportId} deleteEventCallback={openReturnHasBeenDeletedModal}>
                                <ReportLinesTable key={reportId} reportId={reportId} navigateToCompareReport={navigateToCompareReport} />
                                <ReturnHasBeenDeletedNotificationModal
                                    isModalVisible={isReturnHasBeenDeletedModalOpen}
                                    onConfirm={onConfirmDeletionModal}
                                />
                            </TaxReturnEventHandlerProvider>
                        </VarianceNavigationContextProvider>
                    </FormViewProvider>
                </GridScrollContextProvider>
            </SearchTableContextProvider>
        </DrillDownContextProvider>
    );
};

export default withAITracking(applicationInsightsReactPlugin, ReportLines, 'Individual return');
